{
  "familyId": "MET-SYMMETRIE",
  "questions": [
    {
      "id": "MET-SYMMETRIE-001",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Hoeveel symmetrielijnen heeft een vierkant?",
      "options": ["4", "2", "1", "8"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Symmetrielijnen",
            "content": "Een symmetrielijn verdeelt een figuur in twee gelijke helften die elkaars spiegelbeeld zijn. Een vierkant heeft 4 symmetrielijnen: 2 door de zijden en 2 door de hoeken (diagonalen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "symmetrie_vierkant",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een vierkant heeft 4 symmetrielijnen: 2 horizontaal/verticaal (door het midden van de zijden) en 2 diagonaal (door de hoeken). Elke lijn verdeelt het vierkant in twee gelijke spiegelhelften.",
        "solutionSteps": [
          "Symmetrielijn = verdeelt figuur in twee spiegelhelften",
          "Vierkant: 1 horizontaal door midden zijden",
          "Vierkant: 1 verticaal door midden zijden",
          "Vierkant: 2 diagonaal door de hoeken",
          "Totaal: 4 symmetrielijnen"
        ],
        "distractorExplanations": {
          "0": "Goed! Een vierkant heeft 4 symmetrielijnen: 2 door de zijden en 2 door de hoeken.",
          "1": "2 klopt voor een rechthoek (die geen vierkant is). Een vierkant heeft er 4: ook de twee diagonalen zijn symmetrielijnen.",
          "2": "1 symmetrielijn klopt voor een gelijkbenige driehoek, maar een vierkant heeft er 4.",
          "3": "8 is te veel. Een vierkant heeft precies 4 symmetrielijnen."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-002",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Welke hoofdletter heeft GEEN symmetrielijn?",
      "options": ["H", "A", "F", "M"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Symmetrie bij letters",
            "content": "Een letter is symmetrisch als je hem kunt vouwen over een lijn zodat beide helften precies op elkaar passen. A heeft een verticale symmetrielijn, H heeft er twee, M heeft een verticale. F heeft er geen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "symmetrie_letters",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De letter F heeft geen symmetrielijn. Als je de F verticaal of horizontaal vouwt, passen de helften niet op elkaar. A heeft een verticale symmetrielijn, H heeft er twee (verticaal en horizontaal), en M heeft een verticale.",
        "solutionSteps": [
          "A: verticale symmetrielijn ✓",
          "H: verticale én horizontale symmetrielijn ✓",
          "M: verticale symmetrielijn ✓",
          "F: geen symmetrielijn (helften passen niet op elkaar)"
        ],
        "distractorExplanations": {
          "0": "H heeft zelfs twee symmetrielijnen: verticaal en horizontaal.",
          "1": "A heeft wél een verticale symmetrielijn: de linker- en rechterhelft zijn elkaars spiegelbeeld.",
          "2": "Goed! De letter F heeft geen symmetrielijn.",
          "3": "M heeft een verticale symmetrielijn: de linker- en rechterhelft zijn elkaars spiegelbeeld."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-003",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Een gelijkzijdige driehoek heeft ... symmetrielijnen.",
      "options": ["1", "3", "2", "6"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Symmetrie bij driehoeken",
            "content": "Een gelijkzijdige driehoek (alle zijden even lang) heeft 3 symmetrielijnen: elke lijn loopt van een hoekpunt naar het midden van de overliggende zijde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "symmetrie_driehoek",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een gelijkzijdige driehoek heeft 3 symmetrielijnen. Elke lijn loopt van een hoekpunt naar het midden van de tegenoverliggende zijde. Dat kan bij alle 3 de hoekpunten.",
        "solutionSteps": [
          "Gelijkzijdig = alle 3 zijden even lang",
          "Symmetrielijn: van hoekpunt → midden overliggende zijde",
          "3 hoekpunten → 3 symmetrielijnen"
        ],
        "distractorExplanations": {
          "0": "1 symmetrielijn klopt voor een gelijkbenige driehoek (2 zijden gelijk), maar een gelijkzijdige driehoek (3 zijden gelijk) heeft er 3.",
          "1": "Goed! Een gelijkzijdige driehoek heeft 3 symmetrielijnen.",
          "2": "2 symmetrielijnen klopt niet voor een driehoek. Het is 1 (gelijkbenig) of 3 (gelijkzijdig).",
          "3": "6 is te veel. Een gelijkzijdige driehoek heeft precies 3 symmetrielijnen."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-004",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Je spiegelt punt A(2, 3) in de verticale lijn x = 5. Wat zijn de coördinaten van het spiegelbeeld?",
      "options": ["(−2, 3)", "(2, 7)", "(5, 3)", "(8, 3)"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "xMin": 0,
            "xMax": 10,
            "yMin": 0,
            "yMax": 6,
            "points": [{"x": 2, "y": 3, "label": "A"}],
            "lines": [{"x": 5, "style": "dashed", "label": "spiegellijn"}]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Spiegelen in een verticale lijn",
            "content": "Bij spiegelen in een verticale lijn (x = k) verandert alleen de x-coördinaat. De afstand van het punt tot de spiegellijn is gelijk aan de afstand van het spiegelbeeld tot de lijn. y blijft hetzelfde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "symmetrie_spiegelen_coord",
      "variantIndex": 4,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Punt A(2, 3) ligt 3 eenheden links van de spiegellijn x = 5 (want 5 − 2 = 3). Het spiegelbeeld ligt 3 eenheden rechts van de lijn: 5 + 3 = 8. De y-coördinaat blijft 3. Dus: (8, 3).",
        "solutionSteps": [
          "Afstand van A tot spiegellijn: 5 − 2 = 3 eenheden",
          "Spiegelbeeld ligt 3 eenheden aan de andere kant: 5 + 3 = 8",
          "y-coördinaat verandert niet bij verticale spiegeling",
          "Spiegelbeeld: (8, 3)"
        ],
        "distractorExplanations": {
          "0": "(−2, 3) zou kloppen als je in de y-as (x = 0) spiegelt, maar de spiegellijn is x = 5.",
          "1": "(2, 7) zou kloppen als je in een horizontale lijn spiegelt, maar de spiegellijn is verticaal (x = 5). Dan verandert de x, niet de y.",
          "2": "(5, 3) is het punt OP de spiegellijn. Het spiegelbeeld ligt even ver aan de andere kant.",
          "3": "Goed! A(2, 3) gespiegeld in x = 5 geeft (8, 3)."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-005",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "fill_in",
      "question": "Een regelmatige zeshoek heeft ... symmetrielijnen. Typ het aantal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6", "zes"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Symmetrie bij regelmatige veelhoeken",
            "content": "Een regelmatige veelhoek met n zijden heeft altijd n symmetrielijnen. Een regelmatige zeshoek heeft dus 6 symmetrielijnen: 3 door tegenoverliggende hoekpunten en 3 door de middens van tegenoverliggende zijden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "symmetrie_zeshoek_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Een regelmatige zeshoek heeft 6 symmetrielijnen. Regel: een regelmatige veelhoek met n zijden heeft n symmetrielijnen. Zeshoek → 6 zijden → 6 symmetrielijnen.",
        "solutionSteps": [
          "Regel: regelmatige n-hoek → n symmetrielijnen",
          "Zeshoek = 6 zijden",
          "Dus: 6 symmetrielijnen"
        ]
      }
    }
  ]
}